import { IndexModel } from "../Support/IndexModel";
export class CampaignCodeIndex extends IndexModel {
    account;
    slug;
    endpoint = '';
    constructor(params) {
        super();
        this.account = params.account;
        this.slug = params.slug;
        this.endpoint = 'campaign/' + this.slug + '/code';
    }
    getData() {
        return super.getData();
    }
}
